import { isArray } from "lodash";
import { IAbsenceGroup } from "src/Pages/Company/Absences/AbsenceGroups/AbsenceGroups.models";

const sortByOrderAndName = (data: IAbsenceGroup[]) =>
  data.sort((a, b) => {
    // First, compare by order
    if (a.order !== b.order) {
      return a.order - b.order;
    }

    // If orders are the same, compare by name
    return a.name.localeCompare(b.name);
  });

/**
 * Function splitting absence groups retreived from API into two collections - active and inactive.
 * Additionally it sorts them by order property.
 * @param {array} data - collection of all absence groups configured for particular company
 * @returns {array} Array of two collections of given absence groups filtered by active status.
 */
export default (data?: IAbsenceGroup[]) => {
  if (!isArray(data)) return [];

  const activeGroups = sortByOrderAndName(data.filter((group) => group.active));
  const inactiveGroups = sortByOrderAndName(
    data.filter((group) => !group.active)
  );

  return [activeGroups, inactiveGroups];
};
